import React from 'react'
import {DataObjectId} from 'yougile-model'
import {Sync} from '@client/sync'
import {ChatKind, useSyncEventUpdateEffect} from '@containers/hooks'
import {ChatSettings} from '@extensions/chat-settings'
import {globals} from '@extensions/globals-base'
import {ErrorBoundary} from '../../common/error-boundary/error-boundary'
import {FeedbackHeader} from './feedback-header'
import {GroupChatHeader} from './group-chat-header'
import {NewsHeader} from './news-header'
import {PersonalChatHeader} from './personal-chat-header'
import {TaskChatHeader} from './task-chat-header'

interface ChatHeaderProps {
  readonly activeChat: ChatKind
  readonly chatId: DataObjectId
}

export const ChatHeader = ({activeChat, chatId}: ChatHeaderProps) => {
  const settingsHub = ChatSettings.getSettingsHub()
  useSyncEventUpdateEffect('custom', {
    companyId: settingsHub.companyId,
    filter: settingsHub.id
  })

  return (
    <ErrorBoundary>
      <>
        {activeChat === 'personal' && (
          <PersonalChatHeader chatId={chatId} companyId={Sync.profileId} />
        )}

        {activeChat === 'group' && <GroupChatHeader chatId={chatId} />}

        {activeChat === 'task' && (
          <TaskChatHeader
            key={settingsHub.timestamp}
            companyId={globals.getCompanyId()}
            chatId={chatId}
          />
        )}

        {activeChat === 'news' && <NewsHeader chatId={chatId} />}
        {activeChat === 'feedback' && <FeedbackHeader chatId={chatId} />}
      </>
    </ErrorBoundary>
  )
}
